import React from "react";

const AdministratorIndex = () => {
  return <>Administrator Index</>;
};

export default AdministratorIndex;
